<template>
  <div class='main'>
    <nav-top></nav-top>
    <el-row type="flex" justify="center">
      <el-col :span="17" class="deatail_content">
        <el-row class="content_cc">
          <el-col :span="24" class="crumbs">
            您的位置：
            <a href="http://www.jssyyjxh.com">江苏省音乐家协会</a> > 报名记录
          </el-col>
        </el-row>
        <el-row>
            <el-col :span="4">
                <tab-vue></tab-vue>
            </el-col>
            <el-col :span="20" style='padding-left:10px;'>
                <enter-vue> </enter-vue>
            </el-col>
        </el-row>
      </el-col>
    </el-row>
    <div class="box_footer">
      <p style="padding:10px 0;">省音协考级报名咨询电话 025-83572077</p>
      <p>苏ICP备：10064548号</p>
    </div>
  </div>
</template>
<script>
import navTop from "@/components/navTop";
import tabVue from "@/components/tabLeft";
import enterVue from "@/components/Enter";
export default {
  components: {
    tabVue,
    enterVue,
    navTop
  },
  data() {
    return {};
  },
  created(){
     window.Global.checkToken()
  },
  methods: {
  }
};
</script>
<style lang="less">
// @import "../../static/less/bg.less";
</style>


   


// WEBPACK FOOTER //
// src/views/indexSign.vue